import request from '@/utils/request';
// 菜单礼包管理相关接口
// 获取销售运营方案列表
export function getManageProgrammeList(params) {
  return request({
    url: '/package/package-programme/manage-programme-data',
    method: 'get',
    params: params
  });
}
// 销售运营礼包
export function getManagePackageList(params) {
  return request({
    url: '/package/package/manage-package-data',
    method: 'get',
    params: params
  });
}
// 方案下礼包数据
export function getPackageList(params) {
  return request({
    url: '/package/package/manage-package',
    method: 'get',
    params: params
  });
}
// 运营人员
export function getOperateUserList(params) {
  return request({
    url: '/package/package/manage-package-user-infos',
    method: 'get',
    params: params
  });
}
// 获取礼包统计
export function getPackStatisticsList(params) {
  return request({
    url: '/count/package/package-statistics',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 获取礼包统计 汇总数据
export function getPackStatisticsTotal(params) {
  return request({
    url: '/count/package/package-statistics-total',
    timeout: 3 * 60 * 1000,
    method: 'get',
    params: params,
    hideLoading: true
  });
}
export function viewSupplierName(params) {
  return request({
    url: '/package/goods/show-supplier-info',
    method: 'get',
    params: params
  });
}
// 根据礼包id获取礼包数据
export function getPackageGoods(params) {
  return request({
    url: '/package/package/manage-package-goods-data',
    method: 'get',
    params: params
  });
}